import { DialogSubClose, DialogSubHeader } from '@src/design-system/dialog';
import { useFormikContext } from 'formik';
import { Tabs, TabsList, TabsTrigger } from '@src/design-system/tabs';
import { cn } from '@src/design-system/helpers';
import { TabsContent } from '@radix-ui/react-tabs';

import type { TAppointmentFormValues } from '@shared/forms/appointment';
import { INTERVIEWER_TYPES } from '@shared/types/interviewer';
import { InterviewersList } from '@src/shared/components/interviewers-list';
import { formatTextForDisplay } from '@shared/utils/helpers/format-text-for-display';

export function ChooseInterviewerSubModal() {
  const { setFieldValue, values } = useFormikContext<TAppointmentFormValues>();

  const selectedInterviewer = values.host;

  return (
    <div>
      <DialogSubHeader>Choose Interviewer</DialogSubHeader>
      <Tabs defaultValue={INTERVIEWER_TYPES.external}>
        <div className='flex gap-2'>
          <TabsList className='border-0 h-auto gap-2 p-3 pb-0'>
            {Object.values(INTERVIEWER_TYPES).map((value) => (
              <TabsTrigger
                key={value}
                value={value}
                className={cn(
                  `px-4 py-2 font-medium border capitalize transition-none data-[state=active]:bg-primary-100 cursor-pointer data-[state=active]:border data-[state=active]:border-pale-border border-pale-border text-gray-600 rounded-full`
                )}
              >
                {formatTextForDisplay(value)}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
        <TabsContent
          className='text-gray-500 mt-0'
          value={INTERVIEWER_TYPES.external}
        >
          <InterviewersList
            onClickItem={(item) => {
              setFieldValue('host', item);
            }}
            props={{
              infiniteListProps: {
                query: { type: INTERVIEWER_TYPES.external },
              },
            }}
            CloseListTrigger={DialogSubClose}
            isItemSelected={(item) => item.id === selectedInterviewer?.id}
          />
        </TabsContent>

        <TabsContent
          className='text-gray-500 mt-0'
          value={INTERVIEWER_TYPES.member}
        >
          <InterviewersList
            onClickItem={(item) => {
              setFieldValue('host', item);
            }}
            props={{
              infiniteListProps: {
                query: { type: INTERVIEWER_TYPES.member },
              },
            }}
            CloseListTrigger={DialogSubClose}
            isItemSelected={(item) => item.id === selectedInterviewer?.id}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
